<ng-container>
    @if (!isDismissable()) {
        <div class="ap-chip" data-testid="ap-chip-container" [ngClass]="{ 'ap-chip--selected': selected() }">
            @if (iconName()) {
                <ap-icon [name]="iconName()" [manualSize]="16" data-testid="ap-chip-icon"></ap-icon>
            }
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
    }

    @if (isDismissable()) {
        <div class="ap-chip ap-chip--dynamic" data-testid="ap-chip-container">
            @if (iconName()) {
                <ap-icon [name]="iconName()" [manualSize]="16" data-testid="ap-chip-icon"></ap-icon>
            }
            <ng-container *ngTemplateOutlet="content"></ng-container>
            <button
                class="ap-chip-dismiss-button"
                aria-label="Close"
                (click)="dismiss.emit()"
                (keydown.enter)="dismiss.emit()"
                (keydown.space)="dismiss.emit()"
                data-testid="ap-chip-dismiss-button"
            >
                <ap-icon [name]="'close'" size="small"></ap-icon>
            </button>
        </div>
    }
</ng-container>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
